// package imports
import React, { useState } from 'react';

// CSS imports
import './RequestUserCard.css';

// Component imports
import DropdownSelector from '../dropdownSelector/DropdownSelector';
import DeleteButton from '../buttons/deleteButton/DeleteButton';
import ConfirmButton from '../buttons/confirmButton/ConfirmButton';
import Spinner from '../spinner/Spinner';

// Image imports
import DefaultUser from '../../assets/images/defaultUser.jpg';

// Type imports
import { UserRequest } from '../../types/user/UserRequest';

// Special imports
import { config } from '../../config';

type Props = {
  className?: string;
  user: UserRequest;
  index: number;
  declineUser: (id: string, x: number) => Promise<void>;
  acceptUser: (id: string, index: number, role: string) => Promise<void>;
};

const RequestUserCard: React.FC<Props> = ({
  className,
  user,
  index,
  declineUser,
  acceptUser,
}: Props) => {
  const [selectedRole, setSelectedRole] = useState(config.roles.length - 1);
  const [isLoading, setIsLoading] = useState(false);

  const onRoleChange = (newRole: number) => {
    setSelectedRole(newRole);
  };

  const triggerDeclineUser = async () => {
    setIsLoading(true);
    await declineUser(user.id, index);
    setIsLoading(false);
  };

  const triggerAcceptUser = async () => {
    setIsLoading(true);
    await acceptUser(user.id, index, config.roles[selectedRole]);
    setIsLoading(false);
  };

  return (
    <div className={`RequestUserCard ${className ? className : ''}`}>
      <div className='side-container'>
        <img src={DefaultUser} alt='Default user' />
        <span>{user.email}</span>
      </div>
      <div className='side-container'>
        <DropdownSelector
          selectedElement={selectedRole}
          elements={config.roles.map((role, index) => {
            return {
              value: index,
              label: role,
            };
          })}
          onChange={onRoleChange}
          className='role-selector'
        />
        <ConfirmButton onClick={triggerAcceptUser} />
        <DeleteButton onClick={triggerDeclineUser} />
      </div>
      {isLoading ? (
        <div className='loader-overlay'>
          <Spinner isLoading={true} />
        </div>
      ) : null}
    </div>
  );
};

export default RequestUserCard;
